export default __webpack_public_path__ + "static/kyve-8d5e30e29bde2c890d7390487e5ac4a5.svg";